import { GET_ENROLLMENTS } from "constants/enrollments";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_ENROLLMENTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
